export default __webpack_public_path__ + "static/media/slack_info.6c7376c4.png";